import { useQuery } from '@tanstack/react-query';
import { premiumBotStatsService } from '@/services/admin/premium-bot-stats-service';

export const usePremiumBotStats = () => {
  return useQuery({
    queryKey: ['premium-bot-stats'],
    queryFn: () => premiumBotStatsService.getPremiumBotStats(),
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};